import React from "react";
import "./Sponsors.css";
import EmailIcon from "@mui/icons-material/Email";
import ti_logo_red from "../imgs/ti_logo_red.png";
import ni_logo from "../imgs/NI_logo.png";
import fnn_logo from "../imgs/fnn_logo.png";
import google_logo from "../imgs/Google_logo.png";
import L3_logo from "../imgs/L3_logo.png";
import { Margin, Padding } from "@mui/icons-material";

const Sponsors = () => {
  return (
    <div className="sponsorPage">
      <div className="blackText">
        <div className="navbarSpace"></div>
        <div className="header-title">Sponsors</div>
      </div>

      <div className="sponsor-container">
        <div className="image-container">
          <a
            href="https://www.ti.com/"
            target="_blank"
            rel="noopener noreferrer"
            title="link to TI"
          >
            <img className="TI_logo" src={ti_logo_red} alt="TI logo" />
          </a>
        </div>
        <div className="image-container">
          <a
            href="https://www.fireneuralnetwork.com/"
            target="_blank"
            rel="noopener noreferrer"
            title="link to Fire Neural Network"
          >
            <img
              className="fnn_logo"
              src={fnn_logo}
              alt="Fire Neural Network logo"
            />
          </a>
        </div>
        <div className="image-container">
          <a
            href="https://www.l3harris.com/"
            target="_blank"
            rel="noopener noreferrer"
            title="link to L3Harris"
          >
            <img className="L3_logo" src={L3_logo} alt="L3Harris logo" />
          </a>
        </div>
      </div>
      {/* This is second row of companies (only 2 so it needs diff format) */}
      <div className="sponsor-container-2">
        <div className="image-container">
          <a
            href="https://www.ni.com/en.html"
            target="_blank"
            rel="noopener noreferrer"
            title="link to NI"
          >
            <img className="ni_logo" src={ni_logo} alt="NI logo" />
          </a>
        </div>
        <div className="image-container">
          <a
            href="https://about.google/"
            target="_blank"
            rel="noopener noreferrer"
            title="link to Google"
          >
            <img className="google_logo" src={google_logo} alt="Google logo" />
          </a>
        </div>
      </div>
      
      <div className="packet-description">
        <div className="packet-title">        
          UF WECE Corporate Sponsor Packet
        </div>      
        <iframe 
          src="https://drive.google.com/file/d/1FMb_-Jcnx3K7KKdVrpNoPSFW-A4af7hp/preview" 
          width="1080" 
          height="960" 
          allow="autoplay">
        </iframe>
      </div>

      <div className="description">
        <p>
          WECE strives to provide a variety of opportunities that will benefit
          all students and empower women in STEM fields. We are committed to
          establishing strong partnerships between students, faculty, and
          industry in ECE. We would not be able to become successful without the
          aid of our sponsors. Our sponsors provide the support that allows WECE
          to host events and activities. 
        </p>
        
        
        <p>
          We hope to strengthen our corporate
          relations and expand WECE's influence within and beyond the university
          campus. Our partner companies receive the unique opportunity of having
          easy access to the resumes of our members and getting to meet and talk
          to them in person. 

        </p>
      </div>
      
      <div className="blackText">
        <a
          href="https://www.uff.ufl.edu/giving-opportunities/020077-wece-student-organization/"
          target="_blank"
          rel="noopener noreferrer"
          title="link to sponsor donation page"
          class="sponsorship-link"
        >
          Click here to donate!
        </a>

        <p>
          If you have any questions or concerns, please contact our <a href="mailto:vpexternal.wece@gmail.com">VP External</a>!
        </p>
      </div>
    </div>
  );
};

export default Sponsors;
